export namespace CARD_TYPES {
  export const ANY = "Any";
  export const VEHICLE = "Vehicle";
  export const DRIVER_VEHICLE = "DriverVehicle";
  export const DRIVER = "Driver";
}
